import { useEffect, useState } from "react";
import Button from "src/components/atoms/Button";
import { useModal } from "src/hooks/useModal";
import LoginForm from "../Forms/LoginForm";
import RegisterForm from "../Forms/RegisterForm";

interface Props {
  onLoginRedirect?: string;
}

const LoginModal: React.FC<Props> = ({ onLoginRedirect }) => {
  const [state, setState] = useState<"login" | "register">("login");
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    if (onLoginRedirect) {
      localStorage.setItem("loginRedirect", onLoginRedirect);
    }
  }, []);

  if (state === "login") {
    return (
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <LoginForm onLogin={closeModal} />
        <div className="mb-6 mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="bg-white px-2 text-gray-500">o</span>
            </div>
          </div>
        </div>
        <Button
          onClick={() => setState("register")}
          variant={"solid"}
          color={"secondary"}
          size={"lg"}
          type={"button"}
          block={true}
        >
          Regitrarme
        </Button>
      </div>
    );
  } else {
    return (
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <RegisterForm onRegister={closeModal} />
        <div className="mb-6 mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="bg-white px-2 text-gray-500">o</span>
            </div>
          </div>
        </div>
        <Button
          onClick={() => setState("login")}
          variant={"solid"}
          color={"secondary"}
          size={"lg"}
          type={"button"}
          block={true}
        >
          Iniciar Sesión
        </Button>
      </div>
    );
  }
};

export default LoginModal;
